// import React from "react";
// import { Plus, Trash2 } from "lucide-react";

// export default function FXRatesSection({
//   fxRates,
//   isEditing,
//   saving,
//   canManage,
//   onStartEdit,
//   onCancelEdit,
//   onSave,
//   onChange,
//   onAddRow,
//   onRemoveRow,
// }) {
//   const currencies = ["CAD", "USD", "EUR", "AED"];

//   return (
//     <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-10 mb-10">
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-8">
//         <div>
//           <h2 className="text-3xl font-bold text-gray-900">FX Rates</h2>
//         </div>

//         <div className="flex items-center gap-4">
//           {isEditing ? (
//             <>
//               <button
//                 onClick={onCancelEdit}
//                 className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-2xl transition-all"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={onSave}
//                 disabled={saving || !canManage}
//                 className={`px-6 py-3 font-semibold rounded-2xl flex items-center gap-3 transition-all shadow-lg active:scale-98 ${
//                   saving
//                     ? "bg-gray-400 text-gray-100 cursor-not-allowed"
//                     : "bg-black text-white hover:bg-gray-800"
//                 }`}
//               >
//                 {saving ? "Saving..." : "Save Changes"}
//               </button>
//             </>
//           ) : (
//             <button
//               onClick={onStartEdit}
//               disabled={!canManage}
//               className={`px-6 py-3 font-semibold rounded-2xl transition-all shadow-lg active:scale-98 ${
//                 canManage
//                   ? "bg-black text-white hover:bg-gray-800"
//                   : "bg-gray-300 text-gray-600 cursor-not-allowed"
//               }`}
//             >
//               Edit
//             </button>
//           )}
//         </div>
//       </div>

//       <div className="overflow-x-auto border border-gray-200 rounded-2xl">
//         <table className="min-w-full text-sm">
//           <thead className="bg-gray-50 text-gray-700">
//             <tr>
//               <th className="px-4 py-3 text-left font-semibold">Currency</th>
//               <th className="px-4 py-3 text-right font-semibold">Actual FX vs CAD</th>
//               <th className="px-4 py-3 text-right font-semibold">
//                 Buffered FX vs CAD
//               </th>
//               <th className="px-4 py-3 text-center font-semibold">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {(Array.isArray(fxRates) ? fxRates : []).map((row, index) => (
//               <tr key={`fx-${index}`} className="border-t border-gray-200">
//                 <td className="px-4 py-3">
//                   {isEditing ? (
//                     <select
//                       value={row.currency || ""}
//                       onChange={(e) => onChange(index, "currency", e.target.value)}
//                       className="w-full rounded-xl px-3 py-2 border border-gray-300 focus:border-black focus:ring-1 focus:ring-black bg-white"
//                     >
//                       <option value="">Select Currency</option>
//                       {currencies.map((curr) => (
//                         <option key={curr} value={curr}>
//                           {curr}
//                         </option>
//                       ))}
//                     </select>
//                   ) : (
//                     <div className="px-3 py-2 text-gray-700 font-medium">
//                       {row.currency || "—"}
//                     </div>
//                   )}
//                 </td>

//                 <td className="px-4 py-3">
//                   <input
//                     type="number"
//                     min="0"
//                     step="0.0001"   // Better precision for FX rates
//                     value={row.actualFxVsCad || ""}
//                     onChange={(e) =>
//                       onChange(index, "actualFxVsCad", e.target.value)
//                     }
//                     disabled={!isEditing}
//                     className={`w-full rounded-xl px-3 py-2 border text-right ${
//                       isEditing
//                         ? "border-gray-300 focus:border-black focus:ring-1 focus:ring-black"
//                         : "border-transparent bg-transparent text-gray-700"
//                     }`}
//                   />
//                 </td>

//                 <td className="px-4 py-3">
//                   <input
//                     type="number"
//                     min="0"
//                     step="0.0001"
//                     value={row.bufferedFxVsCad || ""}
//                     onChange={(e) =>
//                       onChange(index, "bufferedFxVsCad", e.target.value)
//                     }
//                     disabled={!isEditing}
//                     className={`w-full rounded-xl px-3 py-2 border text-right ${
//                       isEditing
//                         ? "border-gray-300 focus:border-black focus:ring-1 focus:ring-black"
//                         : "border-transparent bg-transparent text-gray-700"
//                     }`}
//                   />
//                 </td>

//                 <td className="px-4 py-3 text-center">
//                   <button
//                     type="button"
//                     onClick={() => onRemoveRow(index)}
//                     disabled={!isEditing}
//                     className={`inline-flex items-center justify-center p-2 rounded-lg ${
//                       isEditing
//                         ? "text-red-600 hover:bg-red-50"
//                         : "text-gray-300 cursor-not-allowed"
//                     }`}
//                   >
//                     <Trash2 className="w-4 h-4" />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="mt-4">
//         <button
//           type="button"
//           onClick={onAddRow}
//           disabled={!isEditing}
//           className={`px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 ${
//             isEditing
//               ? "bg-black text-white hover:bg-gray-800"
//               : "bg-gray-200 text-gray-500 cursor-not-allowed"
//           }`}
//         >
//           <Plus className="w-4 h-4" />
//           Add Row
//         </button>
//       </div>
//     </div>
//   );
// }













import React from "react";
import { Plus, Trash2 } from "lucide-react";

export default function FXRatesSection({
  fxRates,
  isEditing,
  saving,
  canManage,
  onStartEdit,
  onCancelEdit,
  onSave,
  onChange,
  onAddRow,
  onRemoveRow,
}) {
  const currencies = ["CAD", "USD", "EUR", "AED"];

  // Handle percentage change + auto calculate buffered FX
  const handlePercentageChange = (index, value) => {
    const percentage = parseFloat(value) || 0;
    const actual = parseFloat(fxRates[index]?.actualFxVsCad) || 0;

    const buffered = actual + (actual * percentage) / 100;

    onChange(index, "percentage", value);
    onChange(index, "bufferedFxVsCad", buffered.toFixed(4));
  };

  // Handle actual FX change + recalculate buffered FX
  const handleActualFxChange = (index, value) => {
    const actual = parseFloat(value) || 0;
    const percentage = parseFloat(fxRates[index]?.percentage) || 0;

    const buffered = actual + (actual * percentage) / 100;

    onChange(index, "actualFxVsCad", value);
    onChange(index, "bufferedFxVsCad", buffered.toFixed(4));
  };

  return (
    <div className="bg-white rounded-3xl shadow-lg border border-gray-200 p-10 mb-10">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-8">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">
            FX Rates
          </h2>
        </div>

        <div className="flex items-center gap-4">
          {isEditing ? (
            <>
              <button
                onClick={onCancelEdit}
                className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-2xl transition-all"
              >
                Cancel
              </button>

              <button
                onClick={onSave}
                disabled={saving || !canManage}
                className={`px-6 py-3 font-semibold rounded-2xl flex items-center gap-3 transition-all shadow-lg active:scale-98 ${
                  saving
                    ? "bg-gray-400 text-gray-100 cursor-not-allowed"
                    : "bg-black text-white hover:bg-gray-800"
                }`}
              >
                {saving ? "Saving..." : "Save Changes"}
              </button>
            </>
          ) : (
            <button
              onClick={onStartEdit}
              disabled={!canManage}
              className={`px-6 py-3 font-semibold rounded-2xl transition-all shadow-lg active:scale-98 ${
                canManage
                  ? "bg-black text-white hover:bg-gray-800"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
            >
              Edit
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto border border-gray-200 rounded-2xl">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">
                Currency
              </th>

              <th className="px-4 py-3 text-right font-semibold">
                Actual FX vs CAD
              </th>

              <th className="px-4 py-3 text-right font-semibold">
                Buffer %
              </th>

              <th className="px-4 py-3 text-right font-semibold">
                Buffered FX vs CAD
              </th>

              <th className="px-4 py-3 text-center font-semibold">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {(Array.isArray(fxRates) ? fxRates : []).map((row, index) => (
              <tr
                key={`fx-${index}`}
                className="border-t border-gray-200"
              >
                {/* Currency */}
                <td className="px-4 py-3">
                  {isEditing ? (
                    <select
                      value={row.currency || ""}
                      onChange={(e) =>
                        onChange(index, "currency", e.target.value)
                      }
                      className="w-full rounded-xl px-3 py-2 border border-gray-300 focus:border-black focus:ring-1 focus:ring-black bg-white"
                    >
                      <option value="">Select Currency</option>

                      {currencies.map((curr) => (
                        <option key={curr} value={curr}>
                          {curr}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div className="px-3 py-2 text-gray-700 font-medium">
                      {row.currency || "—"}
                    </div>
                  )}
                </td>

                {/* Actual FX */}
                <td className="px-4 py-3">
                  <input
                    type="number"
                    min="0"
                    step="0.0001"
                    value={row.actualFxVsCad || ""}
                    onChange={(e) =>
                      handleActualFxChange(index, e.target.value)
                    }
                    disabled={!isEditing}
                    className={`w-full rounded-xl px-3 py-2 border text-right ${
                      isEditing
                        ? "border-gray-300 focus:border-black focus:ring-1 focus:ring-black"
                        : "border-transparent bg-transparent text-gray-700"
                    }`}
                  />
                </td>

                {/* Percentage */}
                <td className="px-4 py-3">
                  <div className="relative">
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Enter %"
                      value={row.percentage || ""}
                      onChange={(e) =>
                        handlePercentageChange(index, e.target.value)
                      }
                      disabled={!isEditing}
                      className={`w-full rounded-xl px-3 py-2 pr-8 border text-right ${
                        isEditing
                          ? "border-gray-300 focus:border-black focus:ring-1 focus:ring-black"
                          : "border-transparent bg-transparent text-gray-700"
                      }`}
                    />

                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                      %
                    </span>
                  </div>
                </td>

                {/* Buffered FX */}
                <td className="px-4 py-3">
                  <input
                    type="number"
                    min="0"
                    step="0.0001"
                    value={row.bufferedFxVsCad || ""}
                    disabled
                    className="w-full rounded-xl px-3 py-2 border border-transparent bg-gray-100 text-right text-gray-700"
                  />
                </td>

                {/* Action */}
                <td className="px-4 py-3 text-center">
                  <button
                    type="button"
                    onClick={() => onRemoveRow(index)}
                    disabled={!isEditing}
                    className={`inline-flex items-center justify-center p-2 rounded-lg ${
                      isEditing
                        ? "text-red-600 hover:bg-red-50"
                        : "text-gray-300 cursor-not-allowed"
                    }`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add Row */}
      <div className="mt-4">
        <button
          type="button"
          onClick={onAddRow}
          disabled={!isEditing}
          className={`px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 ${
            isEditing
              ? "bg-black text-white hover:bg-gray-800"
              : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
        >
          <Plus className="w-4 h-4" />
          Add Row
        </button>
      </div>
    </div>
  );
}